import React from 'react';

import { DependencyManagerProvider } from 'src/contexts/dependencyManager';
import * as T from './types';
import TinyTracker from 'src/pages/TinyTracker';

// This file is your main component, it's the one that will be rendered by default.
// We recommend to create small components inside the components folder
// and import them here based on your need to make this file easier to understand.
const AppComponent: React.FC<T.AppPropsType> = ({ properties }) => {
  return <TinyTracker />;
};

// This component wraps your main component with the DependencyManagerProvider
// This provider is responsible to manage global dependencies to your component
const App: React.FC<T.AppPropsType> = (props) => {
  return (
    <DependencyManagerProvider>
      <AppComponent {...props} />
    </DependencyManagerProvider>
  );
};

export default App;
